import { create } from 'zustand';
import { BancaResponseTecnicoPage } from '../viewmodel/banca/BancaViewModel';

interface BancaTecnicoStore {
  bancaTecnico: BancaResponseTecnicoPage[];
  videoUploadRequests: number;
  setBancaTecnico: (bancaTecnico: BancaResponseTecnicoPage[]) => void;
  setVideoUploadRequests: (count: number) => void;
  decrementVideoUploadRequests: () => void;
}

const useBancaTecnicoStore = create<BancaTecnicoStore>((set, get) => ({
  bancaTecnico: [],
  videoUploadRequests: 0,
  setBancaTecnico: (bancaTecnico: BancaResponseTecnicoPage[]) => set({ bancaTecnico }),
  setVideoUploadRequests: (count: number) => set({ videoUploadRequests: count }),
  decrementVideoUploadRequests: () => {
    const current = get().videoUploadRequests;
    if (current > 0) {
      set({ videoUploadRequests: current - 1 });
    }
  },
}));

export default useBancaTecnicoStore;
